import * as types from './mutation-types'

export default {

    [types.LOAD_NOTICES] (state, notices) {
        state.notices = notices
    }

    
}
